import { forwardRef } from "react";
import type { EquiplyIconProps, EquiplyIcon } from "../types";

/**
 * Congés / vacances — soleil souriant avec lunettes de soleil.
 * Symbole universel "mode vacances", instantanément lisible, plus chaleureux
 * qu'un palmier ou un parasol.
 */
export const LeavesIcon: EquiplyIcon = forwardRef<SVGSVGElement, EquiplyIconProps>(
  ({ size = 24, ...props }, ref) => (
    <svg ref={ref} width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      {/* Rayons du soleil */}
      <path
        d="M12 1.5v2M12 20.5v2M1.5 12h2M20.5 12h2M4.5 4.5l1.4 1.4M18.1 18.1l1.4 1.4M4.5 19.5l1.4-1.4M18.1 5.9l1.4-1.4"
        stroke="var(--equiply-icon-fg)" strokeWidth="1.5" strokeLinecap="round"
      />
      {/* Disque du soleil (menthe) */}
      <circle cx="12" cy="12" r="7" fill="var(--equiply-icon-bg)" />
      <circle cx="12" cy="12" r="7" stroke="var(--equiply-icon-fg)" strokeWidth="1.5" />
      {/* Lunettes : verres */}
      <ellipse cx="9" cy="10.5" rx="2.2" ry="1.7" fill="var(--equiply-icon-fg)" />
      <ellipse cx="15" cy="10.5" rx="2.2" ry="1.7" fill="var(--equiply-icon-fg)" />
      {/* Lunettes : pont */}
      <path d="M11.2 10.5h1.6" stroke="var(--equiply-icon-fg)" strokeWidth="1.25" strokeLinecap="round" />
      {/* Sourire */}
      <path
        d="M9.5 14.5c.7.8 1.5 1.2 2.5 1.2s1.8-.4 2.5-1.2"
        stroke="var(--equiply-icon-fg)" strokeWidth="1.5" strokeLinecap="round"
      />
    </svg>
  ),
);
LeavesIcon.displayName = "LeavesIcon";
